<script>
  import { mapGetters, mapActions } from 'vuex'
  import * as Helper from '@/modules/helper/index'
  export default {
    props: {
      subNavBar: {
        type: [Boolean, String],
        default: false
      }
    },
    computed: {
      ...mapGetters([
        'MainMenuLayout',
        'MainMenuList',
        'MainMenu',
        'DesignSettings'
      ]),
      getContainerOpacity() {
        let styl = {
          'background': 'rgba(0, 0, 0, 0.5) !important'
        }
        if (Helper.IsValid(this.MainMenu.MenuItemContainerOpacity)) {
          let hashCode = Helper.HashCodeFromInt(this.DesignSettings.BackgroundColor)
          let colorrgb = Helper.hexToRgb(hashCode)
          styl = {
            'background': 'rgba(' + colorrgb + ',' + this.MainMenu.MenuItemContainerOpacity + ') !important'
          }
        }
        return styl
      },
      getStyle() {
        let MenuItemFontColorNoHash = Helper.HashCodeFromInt(this.MainMenu.MenuItemFontColor).substring(1)
        // console.log('this.MainMenu',MenuItemFontColorNoHash)
        return `background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg%20viewBox%3D'0%200%2060%20120'%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%3E%3Cpath%20d%3D'm60%2061.5-38.25%2038.25-9.75-9.75%2029.25-28.5-29.25-28.5%209.75-9.75z'%20fill%3D'%23${MenuItemFontColorNoHash}'%2F%3E%3C%2Fsvg%3E")`
      },
      legalInformationElements() {
        let legalInformationData = this.MainMenu.LegalInformation
        let legalInformation
        if (Helper.IsValid(legalInformationData)) {
          legalInformation = JSON.parse(legalInformationData)
        }
        return legalInformation
      },
      randomNo() {
        return Helper.getRandomInt()
      }
    },
    methods: {
      ...mapActions([
        'setSidePanelActive',
        'setPanelValue'
      ]),
      getMedia(value) {
        // console.log('value',value)
        return `<img src="${value}">`
      }
    },
    mounted() {
      if (this.$refs.sideMenuPanel) {
        this.$refs.sideMenuPanel.$on('panel:open', (event, payload) => {
          this.$refs.sideMenuPanel.$el.scrollTop = 0
        })
        this.$refs.sideMenuPanel.$on('panel:opened', (event, payload) => {
          this.setPanelValue(this.$refs.sideMenuPanel)
          this.setSidePanelActive(true)
        })
        this.$refs.sideMenuPanel.$on('panel:closed', (event, payload) => {
          this.setSidePanelActive(false)
        })
      }
    },
    beforeDestroy() {
      if (this.$refs.sideMenuPanel) {
        this.$refs.sideMenuPanel.$off('panel:opened', (event, payload) => {
          this.setSidePanelActive(true)
        })
        this.$refs.sideMenuPanel.$off('panel:closed', (event, payload) => {
          this.setSidePanelActive(false)
        })
      }
    }
  }
</script>
<template>
  <div class="panel-wrapper">
    <div class="panel-backdrop" style=""></div>
    <f7-panel right cover :id="`sideMenu-panel`" ref="sideMenuPanel" :style="getContainerOpacity">
      <f7-row>
        <f7-col>
          <f7-link panel-close class="custom-panel-close-link">
            <f7-icon icon="icon-close"></f7-icon>
          </f7-link>
        </f7-col>
      </f7-row>
     
      <div class="list sideMenuListMain" :class="{listIos:$theme.ios,listMaterial : !$theme.ios, subNavBar : subNavBar && $theme.ios}" id="sideMenuList">
        <ul>
          <li v-for="(MenuItem, index) in MainMenuList" :key="index">
            <!-- <a v-if="MenuItem.Module_Id === 50" :href="`/${MenuItem.url}/${MenuItem.Id}/${MenuItem.LinkedUrl}`" class="item-link panel-close" :key="index">
              <div class="item-content">
                <div v-if="MenuItem.MenuIcon" class="item-media" v-html="getMedia(MenuItem.MenuIcon)">
                </div>
                <div class="item-inner" :style="getStyle">
                  <div class="item-title">{{MenuItem.MenuLabel}}</div>
                  <div class="item-after" v-if="MenuItem.UnreadChatMessageCount && MenuItem.UnreadChatMessageCount > 0"><span class="badge">{{MenuItem.UnreadChatMessageCount}}</span></div>
                </div>
              </div>
            </a> -->
            <a :href="`/${MenuItem.url}/${MenuItem.Id}`" class="item-link panel-close" :key="index">
              <div class="item-content">
                <div v-if="MenuItem.MenuIcon" class="item-media" v-html="getMedia(MenuItem.MenuIcon)">
                </div>
                <div class="item-inner" :style="getStyle">
                  <div class="item-title">{{MenuItem.MenuLabel}}</div>
                  <div class="item-after" v-if="MenuItem.UnreadChatMessageCount && MenuItem.UnreadChatMessageCount > 0"><span class="badge">{{MenuItem.UnreadChatMessageCount}}</span></div>
                </div>
              </div>
            </a>
          </li>
        </ul>
        <div v-if="legalInformationElements" class="legal-section">
        <component v-for="(el,index) in legalInformationElements.elements" :is="'app-' + el.elementType" :key="index" v-bind="el.properties">
        </component>
      
      </div>
      </div>
      
      <!-- <f7-page :page-content="false">
        <f7-navbar sliding class="navbar-background">
          <f7-nav-left v-if="!$theme.md">
            <f7-link></f7-link>
          </f7-nav-left>
          <f7-nav-title>
          </f7-nav-title>
          <f7-nav-right>
            <f7-link panel-close>
              <f7-icon icon="icon-close"></f7-icon>
            </f7-link>
          </f7-nav-right>
        </f7-navbar>
        <div class="backgroundimg"></div>
        <f7-page-content>
          <div class="list" :class="{listIos:$theme.ios,listMaterial : !$theme.ios, subNavBar : subNavBar && $theme.ios}" id="sideMenuList">
            <ul>
              <li v-for="(MenuItem,index) in MainMenuList">
                <a :href="`/${MenuItem.url}/${MenuItem.Id}`" class="item-link panel-close" :key="index">
                  <div class="item-content">
                    <div v-if="MenuItem.MenuIcon" class="item-media" v-html="getMedia(MenuItem.MenuIcon)">
                    </div>
                    <div class="item-inner" :style="getStyle">
                      <div class="item-title">{{MenuItem.MenuLabel}}</div>
                    </div>
                  </div>
                </a>
              </li>
            </ul>
          </div>
          <div v-if="legalInformationElements" class="legal-section">
            <component v-for="(el,index) in legalInformationElements.elements" :is="'app-' + el.elementType" :key="index" v-bind="el.properties">
            </component>
          </div>
        </f7-page-content>
      </f7-page> -->
    </f7-panel>
  </div>
</template>
<style scoped>
  #sideMenu-panel.list ul {
    background-color: transparent!important;
  }
  /* .listMaterial.list ul:before, .listIos.list ul:before {
    background-color: transparent!important;
  } */
  #sideMenuList.list ul {
    background-color: transparent!important;
    background: transparent!important;
  }
  .listMaterial.list {
    margin: 0px;
  }
  .listIos.list {
    margin: 0px;
  }
  /* .subNavBar.list{
    padding-top: 55px!important;
  } */
  html.with-statusbar .framework7-root .panel{
    padding-top: 0px!important;
  }
  /* html.default-statusbar .framework7-root .panel{
    padding-top: 0px!important;
  } */
  .custom-panel-close-link {
    text-align: right;
    display: block;
  }

  #sideMenu-panel.panel{
    overflow: hidden;
  }

  .sideMenuListMain {
    height: calc(100% - 55px);
    overflow: auto;
  }

 .device-iphone-x .sideMenuListMain{
    height: calc(100vh - 100px);
    overflow: auto;
  }
  /* .badge {
    padding :0px;
  } */
</style>



// WEBPACK FOOTER //
// src/components/shared/menu-layout/SideMenu.vue